var _defs, _rect, _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFounderClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 12,
    y1: 10,
    x2: 68,
    y2: 70
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE2D0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 4,
    y: 6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 9,
    floodColor: "#4B3420",
    floodOpacity: 0.08
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 54,
    height: 54,
    rx: 20,
    fill: "url(#bg)",
    filter: "url(#d)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 34,
    r: 6.5,
    stroke: "#073F37",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 52C26.9 45.8 30.6 42.7 36.2 42.7C41.8 42.7 45.5 45.8 47 52",
    stroke: "#073F37",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 36,
    r: 5,
    stroke: "#8B642C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 44.2C51.8 44.4 54.6 47 55.7 51.3",
    stroke: "#8B642C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounderClients);
export default __webpack_public_path__ + "static/media/founder-clients.67de4f93acfabb5880aa45663494c0ec.svg";
export { ForwardRef as ReactComponent };